module.exports = __webpack_public_path__ + "media/images/emblems/Aesch_LU-822e00c014430ec833525582c1672c30.png";